import React from 'react'
import SpinnerAdapter from 'ppbl/components/SpinnerAdapter'
import FooterSection from 'ppbl/components/common/FooterSection'
import HeaderSection from 'ppbl/components/common/HeaderSection'
import clientLogger from 'ppbl/utils/client-logger'
import serverData from 'ppbl/utils/server-data'
import { productTypes } from '../application/constants'
import { clearSessionStorageExceptCampaign } from '../__utils__'
import './index.css'

type Props = {
  applicationType: string
  country: string
}

/**
 * This is a functional component that clears sessionStorage with previous application
 * and redirects to start of fresh application
 * @returns {JSX.Element} - A JSX element
 */

const Start: React.FC<Props> = ({ country, applicationType }) => {
  clearSessionStorageExceptCampaign()
  const {
    context: { resourceBaseUrl },
  } = serverData

  if (!productTypes.includes(applicationType)) {
    clientLogger.info(
      'invalid application type, redirecting to guest flow',
      applicationType,
    )
    window.location.assign(`${resourceBaseUrl}/app/start`)
  } else {
    clientLogger.info('redirecting user to application page 1')
    window.location.assign(
      `/merchant-lending/loanbuilder/application/${country}/${applicationType}/applicationPage1`,
    )
  }

  return (
    <>
      <HeaderSection page="startPage" />
      <div className="spinner">
        <SpinnerAdapter />
      </div>
      <FooterSection page="startPage" />
    </>
  )
}

export default Start
